import React from "react";
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Modal from '@mui/material/Modal';
import { useState } from "react";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function FindCouncellor(){
    const myStyle={
        backgroundImage:'url("https://images.unsplash.com/photo-1544027993-37dbfe43562a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80")',
        height:"100vh",
        backgroundRepeat:"no-repeat",
        backgroundSize:"cover",
        margin:"auto",
        paddingTop:"200px"
    }
    const buttonStyle={
        margin:"auto",
        
    }
    const textStyle={
        fontFamily:"Consolas",
        fontSize:"100px"
    }
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      };
      

    const [open,setOpen]=useState(false);
    const handleOpen=()=>{setOpen(true)};
    const handleClose=()=>{setOpen(false)};
    return (
        
        <div align="center" style={myStyle}>

            <h1 style={textStyle}>"We are here for you"</h1>           
            <Button variant="contained" style={buttonStyle} onClick={handleOpen}>Find Counsellor</Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
           Counsellor Found 
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Contact : 9999999999
          </Typography>
        </Box>
      </Modal>
        
        </div>
        
        
    );
}

export default FindCouncellor;